var exports = {
  "kL": "ChannelSourcePreview.module__container___OWxKSj",
  "mG": "ChannelSourcePreview.module__inline___OWxKSj",
  "FS": "ChannelSourcePreview.module__textContainer___OWxKSj",
  "S7": "ChannelSourcePreview.module__nameRow___OWxKSj",
  "p": "ChannelSourcePreview.module__channelIcon___OWxKSj",
  "oo": "ChannelSourcePreview.module__nameButton___OWxKSj",
  "Ye": "ChannelSourcePreview.module__nameLink___OWxKSj",
  "fh": "ChannelSourcePreview.module__nameText___OWxKSj",
  "W$": "ChannelSourcePreview.module__subtext___OWxKSj",
  "HR": "ChannelSourcePreview.module__subtextMuted___OWxKSj",
  "G4": "ChannelSourcePreview.module__subtextPrimary___OWxKSj",
  "XW": "ChannelSourcePreview.module__subtextBreadcrumb___OWxKSj",
  "$T": "ChannelSourcePreview.module__subtextChevron___OWxKSj",
  "my": "ChannelSourcePreview.module__avatar___OWxKSj",
  "YQ": "ChannelSourcePreview.module__fallbackIcon___OWxKSj",
  "bo": "ChannelSourcePreview.module__focusRingTight___OWxKSj",
};

module.exports = exports;
